import React, { useState, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import PageTitle from '../../../FormElements/PageTitle';
import PageSubtitle from '../../../FormElements/PageSubtitle';
import StatusWidget from '../../../DataTables/DataTableComponents/StatusWidget';
import DropdownList from '../../../FormElements/DropdownList';
import PropertyBasicDetailsCard from '../PropertyBasicDetailsCard';
import PropertyTaxSetupCard from '../PropertyTaxSetupCard';
import PropertyDocumentsCard from '../PropertyDocumentsCard';
import PropertyTaxReturnsCard from '../PropertyTaxReturnsCard';
import PropertyMetricsCard from '../PropertyMetricsCard';
import PropertyBankAccountsCard from '../PropertyBankAccountsCard';
import PropertySubscriptionCard from '../PropertySubscriptionCard';
import PropertyInvoicesCard from '../PropertyInvoicesCard';
import PropertyNotificationsCard from '../PropertyNotificationsCard';

export default function PropertyProfileContainer(props) {
	const [
		category,
		setCategory
	] = useState('Basic Details');

	const [
		property,
		setProperty
	] = useState([]);

	let { id } = useParams();

	useEffect(() => {
		fetch(props.get_property_endpoint.replace('id', id))
			.then((response) => response.json())
			.then((result) => {
				setProperty(result.data);
			});
	}, []);
	// console.log('get property status', property.status);

	return (
		<div>
			<PageTitle title={property.name} />
			<PageSubtitle
				subtitle={
					`${property.address_1}` +
					(property.address_2 ? `, ${property.address_2}, ` : `, `) +
					`${property.city}, ${property.state} ${property.postal_code}`
				}
			/>
			<span className="mb-2">
				<StatusWidget
					status={property.status ? property.status : 'Contact Support'}
					cta={
						property.status === 'Pending - Awaiting Signed POA' ? (
							'poa'
						) : property.status === 'Pending - Awaiting License Survey' ? (
							'license-survey'
						) : (
							'/contact-support'
						)
					}
					state={{ propertyName: property.name }}
				/>
			</span>
			<DropdownList
				label="Select a Category"
				displayLabel={false}
				onChange={(e) => setCategory(e.target.value)}
				id="category"
				name="category"
				value={category}
				data={[
					{
						id: 1,
						name: 'Basic Details'
					},
					{
						id: 2,
						name: 'Documents'
					},
					{
						id: 3,
						name: 'Tax Setup'
					},
					{
						id: 4,
						name: 'Tax Returns'
					},
					{
						id: 5,
						name: 'Metrics'
					},
					{
						id: 6,
						name: 'Bank Accounts'
					},
					{
						id: 7,
						name: 'Subscription'
					},
					{
						id: 8,
						name: 'Invoices'
					},
					{
						id: 9,
						name: 'Notifications'
					}
				]}
			/>
			<div className="PropertyProfileContainer">
				<div className="mx-auto w-full">
					<div>
						{category === 'Basic Details' ? (
							<PropertyBasicDetailsCard
								get_property_endpoint={props.get_property_endpoint}
								get_property_ownership_by_property_endpoint={
									props.get_property_ownership_by_property_endpoint
								}
							/>
						) : category === 'Documents' ? (
							<PropertyDocumentsCard />
						) : category === 'Tax Setup' ? (
							<PropertyTaxSetupCard />
						) : category === 'Tax Returns' ? (
							<PropertyTaxReturnsCard />
						) : category === 'Metrics' ? (
							<PropertyMetricsCard />
						) : category === 'Bank Accounts' ? (
							<PropertyBankAccountsCard />
						) : category === 'Subscription' ? (
							<PropertySubscriptionCard />
						) : category === 'Invoices' ? (
							<PropertyInvoicesCard />
						) : category === 'Notifications' ? (
							<PropertyNotificationsCard />
						) : (
							''
						)}
					</div>
				</div>
			</div>
		</div>
	);
}
